/* Lichcards 12-10-2026 — zwevende "Filter"-knop op collectie- en zoekpagina's (mobiel/tablet).
   Lange lijsten (bijv. Pokémon TCG, 389 producten): zodra de gewone "Filter"-knop bovenaan uit beeld is,
   verschijnt boven de onderbalk een kleine knop "Filter (n)" die dezelfde filterlade opent.
   - Gebruikt de bestaande knop (summary.mobile-facets__open-wrapper): zelfde lade, zelfde tekst, zelfde teller.
   - Verdwijnt bij de footer, als de lade open is en op desktop (zijbalk).
   - Na sluiten terug naar de plek in de lijst (of naar het begin van de resultaten als er gefilterd is).
   Geladen vanuit snippets/lc-more-filters.liquid · opmaak: assets/lc-polish-20261012.css punt 11.
   Uitzetten: de script-regel met lc-sticky-filter.js in snippets/lc-more-filters.liquid weghalen. */
(() => {
  'use strict';
  if (window.__lcStickyFilter) return;
  window.__lcStickyFilter = true;

  const mq = window.matchMedia('(max-width: 1024px)');
  let summary = null;
  let details = null;
  let pill = null;
  let sourceGone = false;   // gewone knop is naar boven uit beeld gescrold
  let footerVisible = false;
  let restoreY = null;      // scrollpositie van vóór het openen via de zwevende knop
  let restoreSearch = null;

  const ICON = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 17" fill="none">' +
    '<path d="M7.63 15.17H6.33V8.44L1.66 2.89V1.84h12.67v1.04L9.89 8.44v4.47l-2.26 2.26Z" fill="currentColor"/></svg>';

  function findSource() {
    summary = document.querySelector('summary.mobile-facets__open-wrapper');
    details = summary ? summary.closest('details') : null;
    return !!summary;
  }

  function labelText() {
    const label = summary.querySelector('.mobile-facets__open-label.medium-hide') ||
      summary.querySelector('.mobile-facets__open-label');
    return (label ? label.textContent : 'Filter').replace(/\s+/g, ' ').trim() || 'Filter';
  }

  function activeCount() {
    const opener = summary.querySelector('[data-lc-filter-count]');
    const fromAttr = opener ? parseInt(opener.getAttribute('data-lc-filter-count'), 10) : NaN;
    if (!Number.isNaN(fromAttr)) return fromAttr;
    const bubble = summary.querySelector('.lc-filter-count');
    return bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
  }

  function build() {
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'lc-sfb';
    pill.hidden = true;
    pill.innerHTML = ICON + '<span class="lc-sfb__label"></span><span class="lc-sfb__count" hidden></span>';
    pill.addEventListener('click', () => {
      if (!summary || !summary.isConnected) findSource();
      if (!summary) return;
      // De lade springt bij openen/sluiten naar de knop bovenaan; onthoud waar de klant in de lijst was.
      restoreY = window.scrollY;
      restoreSearch = window.location.search;
      summary.click();
    });
    document.body.appendChild(pill);
  }

  function render() {
    if (!pill || !summary) return;
    const label = labelText();
    const count = activeCount();
    const labelEl = pill.querySelector('.lc-sfb__label');
    const countEl = pill.querySelector('.lc-sfb__count');
    if (labelEl.textContent !== label) labelEl.textContent = label;
    if (countEl.textContent !== String(count)) countEl.textContent = String(count);
    countEl.hidden = count < 1;

    const show = mq.matches && sourceGone && !footerVisible && !(details && details.open);
    if (show && pill.hidden) {
      pill.hidden = false;
      window.requestAnimationFrame(() => pill.classList.add('is-in'));
    } else if (!show && !pill.hidden) {
      pill.classList.remove('is-in');
      pill.hidden = true;
    }
  }

  function start() {
    if (!findSource()) return;
    build();

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sourceGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      render();
    }).observe(summary);

    // Eerst de echte site-footer (niet een <footer> binnen een kaart verderop in de pagina).
    const footer = document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('footer.shopify-section') || document.querySelector('body > footer');
    if (footer) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => { footerVisible = entry.isIntersecting; });
        render();
      }).observe(footer);
    }

    if (details) {
      details.addEventListener('toggle', () => {
        render();
        if (details.open || restoreY === null) return;
        const y = restoreY;
        const filtersChanged = window.location.search !== restoreSearch;
        restoreY = null;
        window.setTimeout(() => {
          if (!filtersChanged) {
            window.scrollTo(0, y);
            return;
          }
          // Filters aangepast: naar het begin van de (nieuwe) resultaten, net onder de vaste header.
          const grid = document.getElementById('ProductGridContainer');
          if (!grid) return;
          const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 74;
          window.scrollTo(0, Math.max(0, grid.getBoundingClientRect().top + window.scrollY - header - 12));
        }, 80);
      });
    }
    // facets.js ververst de teller na elke filterkeuze
    new MutationObserver(render).observe(summary, { subtree: true, childList: true, characterData: true, attributes: true });
    if (mq.addEventListener) mq.addEventListener('change', render);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
